import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  GetRolesResponse,
  GetRolesWithPermissionsResponse,
} from '../interfaces/get-roles-response.interface';
import { RoleRequest } from '../interfaces/role.request.interface';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  public getRoles(pageNumber = 1, pageSize = 10, name?: string): Observable<GetRolesResponse> {
    let params = new HttpParams().set('PageNumber', pageNumber).set('PageSize', pageSize);

    if (name?.trim()) {
      params = params.set('Name', name.trim());
    }

    return this.http.get<GetRolesResponse>(`${this.baseUrl}${ApiEndpoints.GET_ROLES}`, {
      params,
    });
  }

  public getRolesWithPermissions(): Observable<GetRolesWithPermissionsResponse> {
    return this.http.get<GetRolesWithPermissionsResponse>(
      `${this.baseUrl}${ApiEndpoints.GET_ROLES_WITH_PERMISSIONS}`,
    );
  }

  public updateRole(role: RoleRequest, roleId: number): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}${ApiEndpoints.GET_ROLES}/${roleId}`, role);
  }

  public deleteRole(roleId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}${ApiEndpoints.GET_ROLES}/${roleId}`);
  }

  public addRole(role: RoleRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}${ApiEndpoints.GET_ROLES}`, role);
  }
}
